import { getUrlParam } from './common';

const _host =
  window.location.hostname === 'sduck.net' ||
  window.location.hostname === 'xsm.sduck.net'
    ? 'https://api.sduck.net'
    : 'https://testy6.sduck.net';

/** 根据 URL 参数 webtype 或域名解析 appName，用于下载接口区分应用 */
export function getAppName(): 'sno' | 'xsm' | null {
  if (typeof window === 'undefined') return null;
  const params = new URLSearchParams(window.location.search);
  const webtype = params.get('webtype');
  if (webtype === 'sno') return 'sno';
  if (webtype === 'xsm') return 'xsm';
  const host = window.location.hostname;
  if (
    host === 'sno.sduck.net' ||
    host === 'snotest.sduck.net' ||
    host.endsWith('.sno.sduck.net') ||
    host.endsWith('.snotest.sduck.net')
  ) {
    return 'sno';
  }
  if (
    host === 'xsm.sduck.net' ||
    host === 'xsmtest.sduck.net' ||
    host.endsWith('.xsm.sduck.net') ||
    host.endsWith('.xsmtest.sduck.net')
  ) {
    return 'xsm';
  }
  return null;
}

export function handleDownloadIOSApp(appName?: 'sno' | 'xsm') {
  const source = getUrlParam('source');
  const resolvedAppName = appName || getAppName();
  let url = _host + '/v1/app/download?model=ios';
  if (resolvedAppName) url += `&appName=${resolvedAppName}`;
  if (source) url += `&source=${source}`;
  window.location.href = url;
}

export function handleDownloadAndroidApp(appName?: 'sno' | 'xsm') {
  const source = getUrlParam('source');
  const resolvedAppName = appName || getAppName();
  let url = _host + '/v1/app/download?model=android';
  if (resolvedAppName) url += `&appName=${resolvedAppName}`;
  if (source) url += `&source=${source}`;
  window.location.href = url;
}

export function handleDownloadWindowsApp() {
  const source = getUrlParam('source');
  const appName = getAppName();
  let url = _host + '/v1/app/download?model=windows';
  if (appName) url += `&appName=${appName}`;
  if (source) url += `&source=${source}`;
  window.location.href = url;
}
